module.exports = __webpack_public_path__ + "static/people_pop25-6e9472147f92a7be421a70a1f9baafdd.png";